export default __webpack_public_path__ + "static/media/chevron-right_orange.72b25afa.svg";